export default {
  pluralLowerCase: 'результаты',
  download: 'Загрузить результаты',
  sendToEmail: 'Отправить результаты на почту',
  filter: 'Фильтровать результаты',
  pluralGenitiveLowerCase: 'результатов',
  hide: 'Скрыть результаты',
  cancel: 'Отменить результаты'
};
